import { render, staticRenderFns } from "./CommentsByArea.vue?vue&type=template&id=8b73e59a&scoped=true&"
import script from "./CommentsByArea.vue?vue&type=script&lang=js&"
export * from "./CommentsByArea.vue?vue&type=script&lang=js&"
import style0 from "./CommentsByArea.vue?vue&type=style&index=0&id=8b73e59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b73e59a",
  null
  
)

export default component.exports